import { Component, OnInit, Input } from "@angular/core";
import * as _ from "lodash";

@Component({
  selector: "metric-settings-tile",
  templateUrl: "./metric-settings-tile.component.html",
  styleUrls: ["./metric-settings-tile.component.scss"],
})
export class MetricSettingsTileComponent implements OnInit {
  @Input() district;
  @Input() goals;
  @Input() selectedMetricData;
  @Input() metric;

  partialImagePath: string = "../../assets/images/";
  trend;

  constructor() {}

  ngOnInit() {}

  getTrendImg() {
    let chartData = this.selectedMetricData.charts.overall.chartData;
    let upIsGood = this.selectedMetricData.upIsGood;
    let trendImg;
    if (chartData.length > 1) {
      this.trend = Math.round((chartData[0].y - chartData[1].y) * 10) / 10;
      if (this.trend > 0) {
        if (upIsGood === true) {
          trendImg = "up_good.png";
        } else if (upIsGood === false) {
          trendImg = "up_bad.png";
        } else {
          trendImg = "up_gray.png";
        }
      } else if (this.trend < 0) {
        if (upIsGood === true) {
          trendImg = "down_bad.png";
        } else if (upIsGood === false) {
          trendImg = "down_good.png";
        } else {
          trendImg = "down_gray.png";
        }
      } else {
        // no change has happened
        trendImg = "sideways_arrow_gray.png";
      }
    }
    return trendImg;
  }

  getChartNames() {
    return ["topBottomRank", "characteristic", "trend", "category", "overall"];
  }

  getColor() {
    let color;
    if (_.has(this.selectedMetricData, "charts.overall.chartData[0].y")) {
      if (
        this.goals &&
        this.goals.updatedData &&
        this.district &&
        this.district.data &&
        this.goals.updatedData[this.district.data.id] &&
        !this.goals.updatedData[this.district.data.id].inactive
      ) {
        if (this.metric && this.metric.up_is_good) {
          color =
            this.selectedMetricData.charts.overall.chartData[0].y >
            this.goals.updatedData[this.district.data.id].goal
              ? "#22b79a"
              : "#ed4c3d";
        } else {
          color =
            this.selectedMetricData.charts.overall.chartData[0].y >
            this.goals.updatedData[this.district.data.id].goal
              ? "#ed4c3d"
              : "#22b79a";
        }
      } else {
        // colour is grey
        color = "#5e5e5e";
      }
      return color;
    }
    return null;
  }
}
